export default __webpack_public_path__ + "static/media/2_stats2.c3e296d0.svg";